import 'bootstrap';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalService } from '@luggagehero/core';
import { NavbarBaseComponent } from '@luggagehero/features/ui';

import { HowItWorksComponent } from '../how-it-works/how-it-works.component';
import { PricingComponent } from '../pricing/pricing.component';

@Component({
  selector: 'lh-navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent extends NavbarBaseComponent {
  private modalService = inject(ModalService);

  public async showHowItWorks(): Promise<void> {
    await this.modalService.show({ component: HowItWorksComponent });
  }

  public async showPriceInfo(): Promise<void> {
    await this.modalService.show({ component: PricingComponent });
  }
}
